import * as types from '../mutation-types'

const { remove, find } = require('@/plugins/lodash')

const state = {
  list: [],
  uploadedList: [],
  addessDataList: []
}

const getters = {
  addressList: (state) => state.list,
  uploadedAddressList: (state) => state.uploadedList,
  savedAddressData: (state) => state.addessDataList
}

const actions = {
  addAddress({ commit }, data) {
    commit(types.ADD_ADDRESS, data)
  },
  setAddressList({ commit }, data) {
    commit(types.SET_ADDRESS_LIST, data)
  },
  setAddressDataList({ commit }, data) {
    commit(types.SET_ADDRESS_DATA_LIST, data)
  },
  addUploadedAddress({ commit }, data) {
    commit(types.ADD_UPLOADED_ADDRESS, data)
  },
  setUploadedAddressList({ commit }, data) {
    commit(types.SET_UPLOADED_ADDRESS_LIST, data)
  },
  draftRemove({ commit }, data) {
    commit(types.REMOVE_BULK_UPLOADED_ADDRESS, data)
  },
  saveAddressData({ commit }, data) {
    commit(types.SAVE_ADDRESS_DATA, data)
  }
}

const mutations = {
  [types.ADD_ADDRESS](state, data) {
    state.list.push(data)
  },
  [types.SET_ADDRESS_LIST](state, data) {
    state.list = data
  },
  [types.SET_ADDRESS_DATA_LIST](state, data) {
    state.addessDataList = data
  },
  [types.ADD_UPLOADED_ADDRESS](state, data) {
    state.uploadedList.push(data)
  },
  [types.SET_UPLOADED_ADDRESS_LIST](state, data) {
    state.uploadedList.push(...data)
  },
  [types.REMOVE_BULK_UPLOADED_ADDRESS](state, data) {
    const loggedTime = data.id
    remove(state.uploadedList, (item) => {
      return item.logged_time == loggedTime
    })
  },
  [types.SAVE_ADDRESS_DATA](state, data) {
    const isExisted = find(state.addessDataList, (address) => {
      return address.lat === data.lat && address.lng === data.lng
    })
    if (isExisted) {
      Object.assign(isExisted, data)
    } else state.addessDataList.push(data)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
